import React from 'react'
import ExpenseCategories from 'src/app/ExpenseCategories/ExpenseCategories'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { expenseCategoriesAdditionalFieldsRouteProps } from 'src/navigation/routeProps'

const ExpenseCategoriesAdditionalFieldsAppRoute: AppRoute = {
  id: AppLocation.OrganizationSettingsExpenseCategoriesAdditionalFields,
  routeProps: expenseCategoriesAdditionalFieldsRouteProps,
  component: <ExpenseCategories />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Settings },
}

export default ExpenseCategoriesAdditionalFieldsAppRoute
